import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useError, useForm } from '../../hooks'
import TextField from '../Form/TextField'
import ColorField from '../Form/ColorField'
import IconField from '../Form/IconField'
import Button from '../Button'
import ContextMenu from '../ContextMenu'
import { useFirebaseCRUD } from '../../hooks/useFirebaseCRUD'
import { serverTimestamp } from 'firebase/firestore'

export const USER_GROUP_FLAGS = {}

export function parseUserGroupFormData(formData, id) {
  const { name, icon, color } = formData
  let flags = 0

  return {
    id,
    name,
    icon,
    color,
    flags,
    createdAt: serverTimestamp()
  }
}

export function UserGroupForm({ defaultValue, getFieldProps }) {
  defaultValue = defaultValue || {}

  return (
    <div>
      <TextField
        label='Name'
        name='name'
        placeholder='Name'
        defaultValue={defaultValue.name}
        required={true}
        {...getFieldProps()}
      />
      <IconField
        label='Icon'
        name='icon'
        iconColor={defaultValue.color || '#000000'}
        defaultValue={defaultValue.icon}
        required={true}
        {...getFieldProps()}
      />
      <ColorField
        label='Color'
        name='color'
        required={true}
        defaultValue={defaultValue.color}
        {...getFieldProps()}
      />
    </div>
  )
}

export default function ({ organizationId }) {
  const navigate = useNavigate()
  const setError = useError()

  const [getFieldProps, formData, formError] = useForm()
  const { createDocument, loading, error } = useFirebaseCRUD()

  async function handleSubmit(e) {
    e.preventDefault()

     try {
      
      const newGroupId = `${Date.now()}`
      const userGroupData = parseUserGroupFormData(formData, newGroupId)

      // ✅ Create document using reusable hook
      const success = await createDocument(
        `organizations/${organizationId}/user-groups/${newGroupId}`,
        userGroupData
      )

      if (success) {
        navigate(-1)
      } else {
        throw new Error('Failed to create user group')
      }
    } catch (err) {
      console.error(err)
      setError(err)
    }
  }

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <UserGroupForm getFieldProps={getFieldProps} />
        <br />
        <div className='flex justify-end'>
          <Button type='submit'>Create</Button>
        </div>
      </form>
    </div>
  )
}
